import React, { useContext, useEffect, useState } from 'react';
import { Button, message, Modal } from 'antd';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import AddForm from './AddFormPageOne';
import axiosApiInstance from '../api/axiosClient';
import { DigitalAssetPageContext } from './DigitalAssetsPage';
import { ProFormInstance } from '@ant-design/pro-form';
import { StepsForm } from '@ant-design/pro-form';
import AddFormPageOne from './AddFormPageOne';
import AddFormSecondPage from './AddFromPageTwo';
import AddFormThirdPage from './AddFormPageThree';

export const checksEnabled = true;

export {
  fetchAssetLabelOptions,
  fetchLabelOptions,
} from '../CRM/pages/DDEXPage/labelOptions';

export const fetchArtistOptions = async () =>
  axiosApiInstance
    .get<API.MusicDistribution.Artist[]>(`/api/artists/`)
    .then(({ data }) => data)
    .then((artists) =>
      artists.map((artist) => ({
        label: artist.key_name,
        value: artist.key_name,
      }))
    )
    .catch((reason) => {
      console.error(reason);
      return [];
    });

type Props = {
  formData: any;
};

const AddEntryStepForm = (formData: Props) => {
  const { stepFormRef, firstFormPageRef, secondFormPageRef, releasesActionRef } = useContext(DigitalAssetPageContext);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const navigate = useNavigate();


  const handleFirstPageFlip = async (
    main_artists: API.MusicDistribution.Artist[],
    featuring_artists: API.MusicDistribution.Artist[]
    ) => {
    console.log('handleFirstPageFlip: ', main_artists, featuring_artists);
    const tracks = secondFormPageRef?.current?.getFieldValue('art_tracks');
    console.log('tracks: ', tracks);
    secondFormPageRef?.current?.setFieldValue(
        'art_tracks',
        tracks.map((track: API.DDEX.Track) => ({ ...track, main_artists, featuring_artists}))
    );
    console.log('end handleFirstPageFlip');
    return Promise.resolve(true);
  };
  const handleFileResourcesUpload = async () => {
    const uploadPromises = [];

    const coverArtFile = firstFormPageRef?.current?.getFieldValue('cover_art_file');
    console.log('ca: ', coverArtFile);
    const uploadCoverArt = async (file) => {
      try {
        const response = await axiosApiInstance.post(
          '/api/digitalassets/generate-archiving-url-upload',
          {
            fileName: file.name,
            fileType: file.type,
            folderName: firstFormPageRef?.current?.getFieldValue('upc_ean'),
          }
        );

        const { presignedUrl } = response.data;

        await axios.put(presignedUrl, file, {
          headers: {
            'Content-Type': file.type,
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            console.log(`Cover art upload progress: ${percentCompleted}%`);
            setUploadProgress((prevProgress) => prevProgress + percentCompleted / uploadPromises.length);
          },
        });

        // message.success('Cover art uploaded successfully');
      } catch (err) {
        console.error('Error uploading cover art:', err);
        message.error('Error uploading cover art');
      }
    };

    const uploadArtTrack = async (file, index) => {
      try {
        const response = await axiosApiInstance.post(
          '/api/digitalassets/generate-archiving-url-upload',
          {
            fileName: file.name,
            fileType: file.type,
            folderName: firstFormPageRef?.current?.getFieldValue('upc_ean'),
          }
        );
        console.log("Uploading file:", file.name, "with type:", file.type);
        console.log("Folder Name:", firstFormPageRef?.current?.getFieldValue('upc_ean'));

        const { presignedUrl } = response.data;

        await axios.put(presignedUrl, file, {
          headers: {
            'Content-Type': file.type,
          },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            console.log(`Art track ${index} upload progress: ${percentCompleted}%`);
            setUploadProgress((prevProgress) => prevProgress + percentCompleted / uploadPromises.length);
          },
        });

        secondFormPageRef?.current?.setFieldValue(['art_tracks', index, 'is_uploaded'], true);
        // message.success(`Art track ${index} uploaded successfully`);
      } catch (err) {
        console.error(`Error uploading art track ${index}:`, err);
        message.error(`Error uploading art track ${index}`);
      }
    };

    const artTracks = secondFormPageRef?.current?.getFieldValue('art_tracks');

    if (coverArtFile && coverArtFile.length > 0) {
      uploadPromises.push(uploadCoverArt(coverArtFile[0].originFileObj));
    }

    artTracks.forEach((track, index) => {
      const audio = track.audio_file;
      // console.log('audio: ', audio);
      if (audio && audio.length > 0) {
        uploadPromises.push(uploadArtTrack(audio[0].originFileObj, index));
      }
    });

    return Promise.all(uploadPromises);
  };


  return (
    <StepsForm
    formRef={stepFormRef}
    onFinish={async (values) => {
      console.log('ONFINISH: ', values);
        values = {
            ...values,
            artists: values.artists?.map((key_name) => ({ key_name })),
            featuring_artists: values.featuring_artists?.map((key_name) => ({ id: key_name })),
            art_tracks: values.art_tracks.map((track) => ({
                ...track,
                main_artists: track.main_artists?.map((key_name) => ({ key_name })),
                featuring_artists: track.featuring_artists?.map((key_name) => ({ key_name })),
                composers: track.composers?.map((key_name) => ({ key_name })),
                authors: track.authors?.map((key_name) => ({ key_name })),
                remixers: track.remixers?.map((key_name) => ({ key_name })),
                producers: track.producers?.map((key_name) => ({ key_name })),
                arrangers: track.arrangers?.map((key_name) => ({ key_name })),
                publishers: track.publishers?.map((key_name) => ({ key_name })),
                recording_engineers: track.recording_engineers?.map((key_name) => ({ key_name })),
                mixing_engineers: track.mixing_engineers?.map((key_name) => ({ key_name })),
                mastering_engineers: track.mastering_engineers?.map((key_name) => ({key_name})),
                executive_producers: track.executive_producers?.map((key_name) => ({ key_name })),
            }))
        };
        console.log(values);

        if (!firstFormPageRef?.current?.getFieldValue('upc_ean')) {
            message.error('UPC/EAN is required');
            return false;
        }
        await handleFileResourcesUpload();
        // return false;
        message.success(`Resources uploaded successfully`);

        await axiosApiInstance.post(`/api/digitalassets/ `, values);
        // message.success('submitted successfully');
        releasesActionRef?.current?.reload();
        // setIsOpen(false);
        // setIsOpen(false);
        setUploadProgress(0);
        return true;
    }}
    onCurrentChange={(current) => {
        // console.log('current: ', current);
        setCurrentStep(current);
    }}
    stepsProps={{ percent: uploadProgress * 100 }}
  >
      <StepsForm.StepForm
        title='Release Information'
        layout='horizontal'
        formRef={firstFormPageRef}
        labelAlign='left'
        grid={true}
        rowProps={{
          gutter: 4,
        }}
        colProps={{ span: 24 }}
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 24 }}
        dateFormatter={(value) => value.format('YYYY-MM-DDTHH:mm:ssZ')}
        onFinish={async ({ artists, featuring_artists }) => {
          console.log("step 1 finish"); 
          await handleFirstPageFlip(artists, featuring_artists);
          return Promise.resolve(true);
      }}
      >
        <AddFormPageOne
            initialValues={{        
                upc_ean: 12345600000      
            }}      
            edit={false}      
        />
      </StepsForm.StepForm>

      <StepsForm.StepForm
    title="Tracks"
    formRef={secondFormPageRef}
    stepProps={{ description: "Input information for each Art Track" }}
    onFinish={ () => {
       console.log("Step 2 finish");
      return Promise.resolve(true);
    }}
      >
        <AddFormSecondPage edit={false}/>
      </StepsForm.StepForm>

      <StepsForm.StepForm
        title='Submit'
        stepProps={{ description: 'Preview & Submit Release', tailContent: 'ASDSADSA' }}
        onFinish={async () => {
          message.success('submitted successfully');
        }}
      >
        {currentStep === 2 && <AddFormThirdPage />}
      </StepsForm.StepForm>
    </StepsForm>
  );
};

export default AddEntryStepForm;